export default __webpack_public_path__ + "static/media/Tesso's Pride.31206c3d.jpg";